import React, {useState} from "react";
import { TrashButton} from "../../assets/GlobalStyles";
import {deleteCustomReportsAxios} from "../../services/reports/ReportsAxios";
import {
  deleteCustomReportsAdminAxios
} from "../../services/reports/ReportsAdminAxios";
import {useAtom, useAtomValue} from "jotai/index";
import {
  reportsInfoAtom,
  tokenResultAtom
} from "../../pages/login/entity/Common";
import {confirmAlert} from "react-confirm-alert";
import {useNavigate} from "react-router-dom";

export function DeleteReport(props){
  const { style, text, reportsInfoId, ...otherProps } = props;
  const tokenResult = useAtomValue(tokenResultAtom);
  const navigate = useNavigate();
  const [reportsInfo, setReportsInfo] = useAtom(reportsInfoAtom)
  /**
   * 보고서 삭제
   * @returns {Promise<void>}
   */
  const deleteReport = async() => {
    if(tokenResult.role === 'NORMAL') {
      await deleteCustomReportsAxios({userId:tokenResult.id, userReportSettingId:reportsInfoId}).then(()=>{
        setReportsInfo({
          id:null,
          groupBy: null
        })
        navigate('/board/reports')
      })
    } else {
      await deleteCustomReportsAdminAxios({email:tokenResult.id, adminReportSettingId:reportsInfoId}).then(()=>{
        setReportsInfo({
          id:null,
          groupBy: null
        })
        navigate('/board/reports')
      })
    }
  }
  const handleDeleteReport = async () => {
    confirmAlert({
      title: '보고서 삭제',
      message: '삭제 하시겠습니까?',
      buttons: [
        {
          label: '삭제',
          onClick: () => deleteReport()
        },{
          label: '취소',
          onClick: () => null
        }
      ]
    });
  }
  return(
      <TrashButton onClick={handleDeleteReport}/>
  );
}
